import React, { Component } from 'react';
import classNames from 'classnames';
import { SelectFileButton } from 'lib/editor/DraftEditor/toolbar';

export function InsertImageButton({ theme, store, onInsert }) {
	const disabled = store && store.getEditorEnviorment() !== 'root';
	return (
		<SelectFileButton
			theme={theme}
			icon="pic"
			disabled={disabled}
			title="插入图片"
			accept=".png, .jpg, .jpeg, .gif"
			onSelect={onInsert}
		></SelectFileButton>
	)
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/imagePlugin/InsertImageButton.jsx